/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signing_Pick_PlaceholderInputs */

const cs_signing_pick_placeholder = /** @type {(inputs: Signing_Pick_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat oprávněná PDF…`)
};

const en_signing_pick_placeholder = /** @type {(inputs: Signing_Pick_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search eligible PDFs…`)
};

/**
* | output |
* | --- |
* | "Search eligible PDFs…" |
*
* @param {Signing_Pick_PlaceholderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const signing_pick_placeholder = /** @type {((inputs?: Signing_Pick_PlaceholderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signing_Pick_PlaceholderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signing_pick_placeholder(inputs)
	return cs_signing_pick_placeholder(inputs)
});